var getPaddingBySize = function (size, hasIcon, isRounded) {
    switch (size) {
        case 'large':
        default:
            return isRounded ? '12px' : '12px 24px';
        case 'medium':
            return isRounded ? '8px' : '8px 24px';
        case 'small':
            return isRounded ? '6px' : "".concat(hasIcon ? 6 : 8, "px 16px");
    }
};
export default getPaddingBySize;
